import React, { useState, useRef } from "react";
import WplSelectInput from "../wpl-select-input/WplSelectInput";
import optionIcon from "../../assets/img/option-icon.png";

const ActionConditionCard = ({
    condition,
    onUpdate,
    isUpdating = false,
    isEditing = false,
    onEditToggle,
    onOptionMenuToggle
}) => {
    const optionRef = useRef();
    const [editedActionType, setEditedActionType] = useState(condition.action_type);

    const handleSave = async () => {
        try {
            await onUpdate(condition.id, editedActionType);
            onEditToggle();
        } catch (error) {
            console.error("Error updating action condition:", error);
        }
    };

    const handleOptionClick = (e) => {
        e.stopPropagation();
        if (optionRef.current) {
            const rect = optionRef.current.getBoundingClientRect();
            onOptionMenuToggle(condition.id, 'action', {
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX + 15,
            });
        }
    };

    const actionTypes = [
        { label: "Uploaded attachment", value: "data_upload" },
        { label: "Marked for repair", value: "marked_for_repair" },
        { label: "Inspection scheduled", value: "inspection_scheduled" }
    ]

    if (isEditing) {
        return (
            <div className={`trigger editing ${isUpdating ? 'updating-row' : ''}`}>
                <p className="trigger-key">Type:</p>
                <WplSelectInput
                    label="Select type"
                    options={actionTypes.map(at => at.label)}
                    value={actionTypes.find(at => at.value === editedActionType)?.label || ""}
                    onChange={(selectedLabel) => {
                        const selected = actionTypes.find(at => at.label === selectedLabel);
                        setEditedActionType(selected?.value || "");
                    }}
                    placeholder="Action type"
                    containerClassName="action-type-selector"
                />
                <div className='trigger-action-container'>
                    <button
                        className='org-btn cancel-btn'
                        disabled={isUpdating}
                        onClick={onEditToggle}
                    >
                        X
                    </button>
                    <button
                        className='org-btn success-btn'
                        disabled={isUpdating}
                        onClick={handleSave}
                    >
                        ✔
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={`trigger ${isUpdating ? 'updating-row' : ''}`}>
            <div
                className='trigger-cell'
                onClick={handleOptionClick}
            >
                <img
                    src={optionIcon}
                    className='action-icon trigger-option-btn'
                    ref={optionRef}
                />
            </div>
            <p className="trigger-key">Type:</p>
            <span className="inline-input">
                <p className="trigger-value">
                    {actionTypes.find(at => at.value === condition.action_type)?.label || condition.action_type}
                </p>
            </span>
        </div>
    );
};

export default ActionConditionCard;